export const varFont = {
  primary: 'Inter',
  secondary: 'Poppins',
};

export const varTypography = {
  fontSize: {
    '8': '8px',
    '10': '10px',
    '12': '12px',
    '13': '13px',
    '14': '14px',
    '16': '16px',
    '24': '24px',
    '36': '36px',
  },
  fontWeight: {
    '300': '300',
    '400': '400',
    '500': '500',
    '600': '600',
    '700': '700',
  },
};

export const varSpacing = {
  xs: '4px',
  sm: '8px',
  md: '16px',
  lg: '24px',
  xl: '48px',
};

export const varColor = {
  primary: '#253D87',
  secondary: '#5C6273',
  info: '#048BA8',
  error: '#FF3B30',
  white: '#FFFFFF',
  black: '#000000',
  red: '#FF4E3E',
  disabled: '#F6F7FC',

  // Text
  textPrimary: '#6C7293',
  textSecondary: '#1C1C1C',
  textSidebar: '#A9B1C7',
  textHeaderUserName: '#021A31',
  textHeaderUserRole: '#697382',
  textLabelField: '#63667A',
  textContentField: '#484955',
  textFileUploadPlaceholder: '#8492BD',
  textGroupForm: '#414B6A',
  textPlaceholderField: '#797B87',
  textContentTable: '#484955',
  textOption: '#374957',
  textTitle: '#050B1C',
  textSubtitle: '#2A3962',
  textValue: '#7B849D',
  textLabelSecondary: '#061851',

  // Border, Divider
  dividerPrimary: '#E8E9EA',
  borderHeaderAction: '#DFDFDF',
  borderPrimary: '#E1E4EB',
  borderTable: '#EDEFF4',

  // Button
  buttonBackgroundHoverPrimary: '#2642a7',

  // Background
  backgroundMenuIcon: '#21304A',
  backgroundMenuItemFrom: '#142642',
  backgroundMenuItemTo: '#010C2E',
  backgroundMenuItemIconActive: '#3652A8',
  backgroundLayout: '#F4F6F9',
  backgroundMenuIconSubmenu: '#A0A3D1',

  // Sidebar
  sidebarPrimary: '#010C2E',
  sidebarLineBreak: '#323A55',

  // Shadow
  shadowMenuOption: '0 11px 60px 0 rgba(10, 26, 73, 0.12)',

  // Backdrop
  backdropBg: '#010C2E',

  // Status
  statusBackgroundDefault: '#F4F6F9',
  statusBackgroundSuccess: '#E9FBF6',
  statusBackgroundWarning: '#FFEDDD',
  statusBackgroundError: '#FFEDEC',
  statusBackgroundInfo: '#e1eefc',
  statusBackgroundPrimary: '#f0f0f0',
  statusBackgroundSecondary: '#ba68c83a',
  statusColorText: '#1F2027',
  statusColorDotSuccess: '#17BD8D',
  statusColorDotWarning: '#FE7700',
  statusColorDotError: '#FF4E3E',
  statusColorDotInfo: '#1486ff',
  statusColorDotPrimary: '#6c79a1',
  statusColorDotSecondary: '#BA68C8',
  statusOnline: '#4CAF50',
  statusOffline: '#AAB2A6',

  // Activity
  activityBgCreate: '#253D87',
  activityBgUpdate: '#FE7700',
  activityBgDelete: '#F14545',
  activityBgUpload: '#FE7700',
  activityBgChange: '#FE7700',
  activityBgAssign: '#FE7700',

  // Schedule
  schedulePrimary: '#b8e6fe',

  // Message
  messageSearchPlaceholder: '#75819F',
  messageSearchBorder: '#DDE3E9',
  messageItemTitle: '#1F2229',
  messageItemContent: '#787E8D',
  messageItemBorder: '#DFE1E3',
  messageInputPlaceholder: '#9BA1B1',
  messageInputBg: '#F5F7FE',
  messageTextContent: '#656975',
  messageUnreadBg: '#305FEE',
  messageIsMyMessageBg: '#F8F9FB',

  // Tab
  tabItemBorder: '#E1E2E5',

  // QuickBooks
  quickBooksConnected: '#4CAF50',
  quickBooksDisconnected: '#D8D8D8',
};
